<div class="report-card">
  <div class="header">
    Completed + Paid Tasks
    <span class="sub-header">
      {{ startDate | date: 'shortDate' }} - {{ endDate | date: 'shortDate' }}
      @if (employee && !companyWide) {
        <span>, {{employee.fullName}}</span>
      }
      @if (companyWide) {
        <span>, All</span>
      }
    </span>
  </div>
  <app-loading-swirly [isLoading]="totalsLoading"></app-loading-swirly>

  @if (!totalsLoading) {
    <div>
      <div class="big-header">
        {{totals.workCurrentRange | currency:'USD':'symbol':'0.0-2' }}
        <span [ngClass]="totals.workPercentageChange >= 0 ? 'small good-text' : 'small bad-text'">
          <i [ngClass]="totals.workPercentageChange >= 0 ? 'pi pi-arrow-up' : 'pi pi-arrow-down'"></i>
          {{ totals.workPercentageChange | absoluteValue | percent }}
        </span>
        <div class="small">
          Tree Work
        </div>
      </div>
      <div class="big-header">
        {{totals.wellnessCurrentRange | currency:'USD':'symbol':'0.0-2' }}
        <span [ngClass]="totals.wellnessPercentageChange >= 0 ? 'small good-text' : 'small bad-text'">
          <i [ngClass]="totals.wellnessPercentageChange >= 0 ? 'pi pi-arrow-up' : 'pi pi-arrow-down'"></i>
          {{ totals.wellnessPercentageChange | absoluteValue | percent }}
        </span>
        <div class="small">
          Tree Wellness
        </div>
      </div>
      <div class="thicker-horizontal-line"></div>
      <div class="big-header">
        <span [ngStyle]="{'color': mainColor}">
          {{(totals.wellnessCurrentRange + totals.workCurrentRange) | currency:'USD':'symbol':'0.0-2' }}
        </span>
        <span [ngClass]="(totals.workPercentageChange + totals.wellnessPercentageChange) >= 0 ? 'small good-text' : 'small bad-text'">
          <i [ngClass]="(totals.workPercentageChange + totals.wellnessPercentageChange) >= 0 ? 'pi pi-arrow-up' : 'pi pi-arrow-down'"></i>
          {{ (totals.workPercentageChange + totals.wellnessPercentageChange) | absoluteValue | percent }}
        </span>
        <div class="small">
          Combined
        </div>
      </div>
    </div>
  }
</div>
